import CTAButton from "./CTAButton";

export default function ProblemSection({ content = {}, onCheckout, canCheckout }) {
  const title = content.title || "Apakah Anda Mengalami Salah Satu Masalah Ini?";
  const desc = content.desc || "";
  const items = content.items || [];

  return (
    <section className="py-20 lg:py-28 bg-gradient-soft">
      <div className="mx-auto max-w-6xl px-5">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Masalah Umum</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-balance">
            {title}
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((p, i) => (
            <div
              key={i}
              className="group flex items-start gap-4 rounded-2xl bg-white border border-border p-5 shadow-card hover:shadow-luxury hover:-translate-y-1 transition-all duration-300"
            >
              <div className="text-3xl">{p.icon || "😩"}</div>
              <div>
                <div className="text-red-500 font-bold text-sm">✕ Masalah</div>
                <div className="font-semibold text-foreground mt-0.5">{p.title || p}</div>
                {p.desc && <div className="text-sm text-muted-foreground mt-1">{p.desc}</div>}
              </div>
            </div>
          ))}
        </div>

        {desc && (
          <p className="mt-10 mx-auto max-w-2xl text-center text-muted-foreground leading-relaxed">
            {desc}
          </p>
        )}

        <div className="mt-8 text-center">
          <CTAButton size="lg" onClick={onCheckout} disabled={!canCheckout}>
            🌺 Saya Ingin Hidup Lebih Sehat
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
